"use client";

import { MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const infoRows = [{
    label: "Service Area",
    value: "West and East Sussex"
  }, {
    label: "Support Hours",
    value: "8:30am–4:30pm, Mon–Fri"
  }, {
    label: "Phone",
    value: "01903 372801"
  }, {
    label: "Email",
    value: "info@coastline-services.co.uk"
  }];
  return <section data-section-id="1504" id="officelocationmap" className="relative w-full bg-background border-t border-b border-border overflow-hidden">
      <div className="max-w-[1320px] mx-auto px-5 md:px-8 py-28 md:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={leftRef} data-index={0} className="lg:col-span-5 transition-all duration-[600ms] ease-out" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(14px)"
        }}>
            {}
            <div className="flex items-center gap-2 mb-8">
              <span className="font-default text-[0.75rem] tracking-[0.18em] uppercase text-muted-foreground font-medium">
                §  note no. 01 — our service hub
              </span>
            </div>

            {}
            <h2 className="font-default text-foreground mb-12" style={{
            fontSize: "clamp(2.25rem, 4.6vw, 4.25rem)",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.04
          }}>
              Expert climate control for your{" "}
              <span className="relative inline-block">
                <em className="not-italic font-default" style={{
                color: "var(--primary)"
              }}>
                  modern space
                </em>
                <svg className="absolute left-0 -bottom-1 w-full" height="10" viewBox="0 0 220 10" fill="none" preserveAspectRatio="none" aria-hidden="true">
                  <path d="M2 6 Q 30 2, 60 5 T 120 5 T 180 4 T 218 6" stroke="var(--primary)" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                </svg>
              </span>{" "}
              needs.
            </h2>

            {}
            <div className="mb-10">
              {infoRows.map((row, i) => <div key={i} data-index={i} className="grid grid-cols-[100px_1fr] sm:grid-cols-[140px_1fr] gap-4 py-5 border-b border-dashed border-border">
                  <span className="font-default text-[0.75rem] tracking-[0.16em] uppercase text-muted-foreground font-medium pt-1">
                    {row.label}
                  </span>
                  <span className="font-default text-foreground" style={{
                fontSize: "1.25rem",
                lineHeight: 1.4,
                fontWeight: 500
              }}>
                    {row.value}
                  </span>
                </div>)}
            </div>

            {}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground px-8 py-6 font-default font-semibold text-[0.875rem] tracking-[0.04em] uppercase transition-all duration-240">
                <Link to="/WhoWeServePage">
                  <MapPin className="size-4" />
                  View Service Areas
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-lg bg-background border-[1.5px] border-foreground text-foreground hover:bg-foreground hover:text-background px-8 py-6 font-default font-semibold text-[0.875rem] tracking-[0.04em] uppercase transition-all duration-220">
                <Link to="tel:+441903372801">
                  <Phone className="size-4" />
                  01903 372801
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} data-index={1} className="lg:col-span-7 relative transition-all duration-[600ms] ease-out" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(14px)",
          transitionDelay: "120ms"
        }}>
            {}
            <div className="absolute -top-8 -right-8 w-[60%] h-[60%] rounded-lg blur-3xl pointer-events-none" style={{
            background: "var(--accent)",
            opacity: 0.4
          }} aria-hidden="true" />
            <div className="absolute -bottom-12 -left-6 w-[50%] h-[50%] rounded-lg blur-3xl pointer-events-none" style={{
            background: "var(--secondary)",
            opacity: 0.25
          }} aria-hidden="true" />

            {}
            <div className="relative bg-card rounded-3xl p-6 md:p-10" style={{
            border: "1px dashed var(--ring)"
          }}>
              {}
              <div className="relative aspect-square md:aspect-[7/5] w-full rounded-2xl overflow-hidden bg-background">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/coastline_service_map.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/coastline_service_map.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/coastline_service_map.png-wvc-sizes" alt="Professional technician installing a high-efficiency air conditioning unit in a modern commercial office space" loading="lazy" decoding="async" className="w-full h-full object-cover max-w-full" />
              </div>

              {}
              <p className="font-default text-[0.75rem] tracking-[0.04em] text-muted-foreground italic mt-5 text-center">
                 serving homes and businesses across the region
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}